/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaInputHelp/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function TysiaInputHelp({
  children,
  viewPath = "/DesignSystem/TysiaInput/TysiaInputHelp",
  text = "Default text",
  marginTop = 4,
  invalid
  
}) {
let dtTysiainputhelpColorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputHelp.color.primary.base'
        })
let dtTysiainputhelpColorPrimaryInvalid = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputHelp.color.primary.invalid'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text={text}
 color={invalid ? dtTysiainputhelpColorPrimaryInvalid : dtTysiainputhelpColorPrimaryBase}
 size="normal"
 weight="regular"
 whiteSpace="nowrap"
 overflowX="hidden"
 textOverflow="ellipsis"
 marginTop={marginTop}
/>
{children}
</React.Fragment>)
}